import { Component, OnInit } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { DialogService } from 'ng2-bootstrap-modal';
import { RenewalModalComponent } from './renewal-modal/renewal-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { BulkRenewalRequestService } from './service/bulk-renewal-request.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BulkRenewalRequest } from '../bulk-renewal.model';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import 'moment/locale/pt-br';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { normalizeDoc } from '../../../cnpj.utils';

@Component({
	selector: 'app-bulk-renewal-request',
	templateUrl: './bulk-renewal-request.component.html',
	styleUrls: ['./bulk-renewal-request.component.scss']
})
export class BulkRenewalRequestComponent implements OnInit {

	private token;
	public permissoes: any[] = [];

	//paginação
	public qtdPorPagina: number = 10;
	public qtdPorPaginaCustom: number = 10;
	public currentPage: number = 0;
	public page: number = 0;
	public orderby = "NomeCliente";
	public sort = "asc";
	public lastFilterExecuted: number = 1;
	public resultCount = 0;

	public bulkRenewalForm: FormGroup;

	public proposalRenovationList: Array<BulkRenewalRequest> = new Array<BulkRenewalRequest>();

	showDropdowns: { [key: string]: boolean } = {
		ctcDropdown: false,
		gcDropdown: false,
		directorDropdown: false,
		typeGuaranteeDropdown: false,
		statusGuaranteeDropdown: false

	};

	public ctcList = [];
	public selectedCTC: string[] = [];
	public gcList = [];
	public selectedGC: string[] = [];
	public directorList = [];
	public selectedDirector: string[] = [];
	public representativeList = [];
	public analystList = [];
	public conceptBillingList = [];
	public typeGuaranteeList = [];
	public selectedTypeGuarantee: string[] = [];
	public selectedStatusGuarantee: string[] = [];

	public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	public cnpjMask = [/[A-Z0-9]/i, /[A-Z0-9]/i, '.', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '.', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '/', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '-', /\d/, /\d/];

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
		//disableUntil: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		//height: "30px"
	};
	
	AtrasoDias: number | null = null;
	public faturamentoColumns: { titulo: string; propriedade: string; tipo: string }[] = [];

	constructor(private fb: FormBuilder, private bulkRenewalRequestService: BulkRenewalRequestService, private dialogService: DialogService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
		this.bulkRenewalForm = this.fb.group({
			'Codigo': '',
			'NomeCliente': '',
			'Apelido': '',
			'Documento': '',
			'NomeGrupo': '',
			'DeVigenciaLC': '',
			'AteVigenciaLC': '',
			'Rating': '',
			'DeValorLC': '',
			'AteValorLC': '',
			'ClienteTop10Sim': '',
			'ClienteTop10Nao': '',
			'DeConsultaSerasa': '',
			'AteConsultaSerasa': '',
			'RestricaoSerasa': '',
			'RestricoesYaraSim': '',
			'RestricoesYaraNao': '',
			'RestricaoSerasaGrupoSim': '',
			'RestricaoSerasaGrupoNao': '',
			'RestricoesYaraGrupoSim': '',
			'RestricoesYaraGrupoNao': '',
			'LCAndamentoSim': '',
			'LCAndamentoNao': '',
			'AlcadaAndamentoSim': '',
			'AlcadaAndamentoNao': '',
			'DeComCompras': '',
			'AteComCompras': '',
			'DeVigenciaGarantia': '',
			'AteVigenciaGarantia': '',
			'RepresentanteID': '',
			'AnalistaID': '',
			'CTC': [[]],
			'GC': [[]],
			'Diretoria': [[]],
			'DePropostaRenovacao': '',
			'AtePropostaRenovacao': '',
			'ClientesRenovadosSim': '',
			'ClientesRenovadosNao': '',
			'DeVigenciaLCAdicional': '',
			'AteVigenciaLCAdicional': '',
			'DeValorLCAdicional': '',
			'AteValorLCAdicional': '',
			'ConceitoCobrancaID': '',

			'Faturamento': '',
			'FaturamentoPeriodo': '',
			'Atraso': '',
			'AtrasoPeriodo': '',
			'Prorrogacao': '',
			'ProrrogacaoPeriodo': '',
			
			'TipoGarantia': [[]],
			'StatusGarantia': [[]] 
		});
	}

	ngOnInit() {
		this.token = localStorage.getItem('yara.token');
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.getCTCList();
		this.getGCList();
		this.getDirectorList();
		this.getRepresentativeList();
		this.getAnalystList();
		this.setFields();
		this.validateForm();
		this.getConceptBillingList();	
		this.generateFaturamentoColumns();
		this.getDelay();
		this.getOptionsGuarantees();
	}

	periodos = [
		{ value: 'Geral', label: 'Geral (Atual + 3 anos anteriores)' },
		{ value: 'AnoAtual', label: 'Ano Atual' },
		{ value: 'AnoAnterior', label: 'Ano Anterior' },
		{ value: 'DoisAnosAnteriores', label: '2 Anos Anteriores' },
		{ value: 'TresAnosAnteriores', label: '3 Anos Anteriores' }
	  ];

	//TODO: Refatorar as listas em HardCode do BD, BE e FE e centralizar as informações em tabelas no BD (TipoGarantia e StatusGarantia)	  
	statusGarantiasList = [
		{ value: "1", label: "Em criação" },
		{ value: "2", label: "Aguardando Informações" },
		{ value: "3", label: "Enviada ao CTC" },
		{ value: "4", label: "Recebido via Digitalizada" },
		{ value: "5", label: "Aguardando Registro" },
		{ value: "6", label: "Recebido Original" },
		{ value: "7", label: "Recebido Original com Pendência" },
		{ value: "8", label: "Encerrada" },
		{ value: "9", label: "Garantia Baixada" },
		{ value: "10", label: "Garantia devolvida ao Cliente" },
		{ value: "11", label: "Garantia Enviada ao Jurídico" },
		{ value: "12", label: "Garantia Vencida" },
		{ value: "default", label: "N/D" }
	  ].map(item => ({ ...item, checked: false }));;
	
	selectListIndexByFilter() {
		const periodoValue = this.bulkRenewalForm.controls['FaturamentoPeriodo'].value;
		const listIndex = [];

		switch(periodoValue) {
			case 'Geral':
				listIndex.push(0, 1, 2, 3);
				break;
			case 'AnoAtual':
				listIndex.push(0);
				break;
			case 'AnoAnterior':
				listIndex.push(1);
				break;
			case 'DoisAnosAnteriores':
				listIndex.push(1, 2);
				break;
			case 'TresAnosAnteriores':
				listIndex.push(1, 2, 3);
				break;
		}
		return listIndex;
	}

	generateFaturamentoColumns() {
		const filterFaturamento = this.bulkRenewalForm.controls['Faturamento'].value;
		this.faturamentoColumns = [];
		const currentYear = new Date().getFullYear();

		for (let i = 0; i < 4; i++) {
			const year = currentYear - i;
			const listIndex = this.selectListIndexByFilter();
			let indexFaturamentoTotal = filterFaturamento === 'FaturamentoTotal' ? listIndex.find(item => item === i) : i;
			let indexFaturamentoPrazo = filterFaturamento === 'FaturamentoPrazo' ? listIndex.find(item => item === i) : i;
			
			this.faturamentoColumns.push({ titulo: `Faturamento Total ${year}`, propriedade: `FaturamentoTotal${indexFaturamentoTotal}`, tipo: 'Number' });
			this.faturamentoColumns.push({ titulo: `Faturamento a Prazo ${year}`, propriedade: `FaturamentoPrazo${indexFaturamentoPrazo}`, tipo: 'Number' });
			this.faturamentoColumns.push({ titulo: `Atraso ${year}`, propriedade: `DiasAtraso${i}`, tipo: '' });
			this.faturamentoColumns.push({ titulo: `Prorrogação ${year}`, propriedade: `Prorrogacao${i}`, tipo: 'Boolean' });
		}
	}	

	mask(): any {
		return {
			mask: (value) => {
				value = normalizeDoc(value);
				if (value.length < 12)
					return this.cpfMask;
				else
					return this.cnpjMask;
			}
		};
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;

		if (this.lastFilterExecuted == 1)
			this.getBulkRenewalList();
		else if (this.lastFilterExecuted == 2)
			this.searchClient();
		else
			console.log("Erro ao executar último filtro.");
	}
	toggleDropdown(field: string) {
		Object.keys(this.showDropdowns).forEach(key => {
		  this.showDropdowns[key] = key === field ? !this.showDropdowns[key] : false;
		});
	  }
	  
	  onCheckboxChange(item: any) {
		item.checked = !item.checked;

		this.updateSelected();
	  }
	  
	updateSelected() {
		this.selectedCTC = this.ctcList.filter(ctc => ctc.checked).map(ctc => ctc.Nome);
		this.bulkRenewalForm.controls.CTC.setValue(
			this.selectedCTC.length > 0 ? this.selectedCTC : null
		);

		this.selectedGC = this.gcList.filter(gc => gc.checked).map(gc => gc.Nome);
		this.bulkRenewalForm.controls.GC.setValue(
			this.selectedGC.length > 0 ? this.selectedGC : null
		);

		this.selectedDirector = this.directorList.filter(dir => dir.checked).map(dir => dir.Nome);
		this.bulkRenewalForm.controls.Diretoria.setValue(
			this.selectedDirector.length > 0 ? this.selectedDirector : null
		);

		this.selectedTypeGuarantee = this.typeGuaranteeList.filter(tg => tg.checked).map(tg => tg.Nome);
		this.bulkRenewalForm.controls.TipoGarantia.setValue(
			this.selectedTypeGuarantee.length > 0 ? this.selectedTypeGuarantee : null
		);

		this.selectedStatusGuarantee = this.statusGarantiasList.filter(item => item.checked).map(item => item.label);
		this.bulkRenewalForm.controls.StatusGarantia.setValue(
			this.selectedStatusGuarantee.length > 0 ? this.selectedStatusGuarantee : null
		);
	}

	getCTCList() {
				const path2Route = this.permissoes['OpcoesCredito_BuscarCTC'] ? 'getcommercialstructurebypapel' : 'getcommercialstructurebypapelrestrict';
			
				this.bulkRenewalRequestService.getCTC(path2Route).subscribe(
				  result => {
					this.ctcList = result.Result.map(ctc => ({
					  ...ctc,
					  checked: false, 
					}));
				  },
				  error => {
					console.error(error);
				  }
				);
			  }
			

	getGCList() {
		let path2Route = this.permissoes['OpcoesCredito_BuscarGC'] ? "getcommercialstructurebypapel" : "getcommercialstructurebypapelrestrict";

		this.bulkRenewalRequestService.getGC(path2Route).subscribe(
			result => {
				this.gcList = result.Result.map(gc => ({
					...gc,
					checked: false,
				}));
			},
			error => {
				console.log(error);
			});
	}

	getDirectorList() {
		let path2Route = this.permissoes['OpcoesCredito_BuscarDIR'] ? "getcommercialstructurebypapel" : "getcommercialstructurebypapelrestrict";

		this.bulkRenewalRequestService.getDirector(path2Route).subscribe(
			result => {
				this.directorList = result.Result.map(dir => ({
					...dir,
					checked: false,
				}));
			},
			error => {
				console.log(error);
			});
	}

	getRepresentativeList() {
		let path2Route = this.permissoes['OpcoesCredito_BuscarREP'] ? "getrepresentative" : "getrepresentativerestrict";

		this.bulkRenewalRequestService.getRepresentative(path2Route).subscribe(
			result => {
				this.representativeList = result.Result;

				if (!this.permissoes['OpcoesCredito_BuscarREP'] && this.representativeList.length > 0) {
					this.bulkRenewalForm.controls.RepresentanteID.setValue(this.representativeList[0].ID);
				}
			},
			error => {
				console.log(error);
			});
	}

	getAnalystList() {
		this.bulkRenewalRequestService.getAnalyst(this.token).subscribe(
			result => {
				this.analystList = result.Result.filter((e, i) => result.Result.findIndex(a => a['Nome'] === e['Nome']) === i);
			},
			error => {
				console.log(error);
			});
	}

	getConceptBillingList() {
		this.bulkRenewalRequestService.getConceptBilling(this.token).subscribe(
			result => {
				this.conceptBillingList = result.Result.filter((e, i) => result.Result.findIndex(a => a['Nome'] === e['Nome']) === i);
			},
			error => {
				console.log(error);
			});
	}
	getDelay(): void {
		this.bulkRenewalRequestService.getDelay().subscribe(
		  (response) => {			
			const result = response.Result;
			this.AtrasoDias = result ? result.Valor : 0;

			console.log("Dias de atraso definido como:", this.AtrasoDias);
		  },
		  (error) => {
			console.error("Erro ao buscar dias de atraso:", error);
		  }
		);
	  }
	  
	getOptionsGuarantees(){
		this.bulkRenewalRequestService.getOptionsGuarantees(this.token).subscribe(
			(response) =>{
					const resultG = response.Result || [];
					console.log(resultG);
						
				  
					this.typeGuaranteeList = response.Result.map(tg => ({
					  ...tg,
					  checked: false, 
					}));
					console.log(this.typeGuaranteeList);
			},
			(error) => {
				console.error("Erro ao buscar garantias", error);
			}
		);
	}
	setFields() {
		const filters = this.bulkRenewalRequestService.getFilters();
		if (filters != null) {
			this.bulkRenewalForm.controls.Codigo.setValue(filters.Codigo);
			this.bulkRenewalForm.controls.NomeCliente.setValue(filters.NomeCliente);
			this.bulkRenewalForm.controls.Apelido.setValue(filters.Apelido);
			this.bulkRenewalForm.controls.Documento.setValue(filters.Documento);
			this.bulkRenewalForm.controls.NomeGrupo.setValue(filters.NomeGrupo);
			this.bulkRenewalForm.controls.DeVigenciaLC.setValue(filters.DeVigenciaLC);
			this.bulkRenewalForm.controls.AteVigenciaLC.setValue(filters.AteVigenciaLC);
			this.bulkRenewalForm.controls.Rating.setValue(filters.Rating);
			this.bulkRenewalForm.controls.DeValorLC.setValue(filters.DeValorLC);
			this.bulkRenewalForm.controls.AteValorLC.setValue(filters.AteValorLC);
			this.bulkRenewalForm.controls.ClienteTop10Sim.setValue(filters.ClienteTop10Sim);
			this.bulkRenewalForm.controls.ClienteTop10Nao.setValue(filters.ClienteTop10Nao);
			this.bulkRenewalForm.controls.DeConsultaSerasa.setValue(filters.DeConsultaSerasa);
			this.bulkRenewalForm.controls.AteConsultaSerasa.setValue(filters.AteConsultaSerasa);
			this.bulkRenewalForm.controls.RestricaoSerasa.setValue(filters.RestricaoSerasa);
			this.bulkRenewalForm.controls.RestricoesYaraSim.setValue(filters.RestricoesYaraSim);
			this.bulkRenewalForm.controls.RestricoesYaraNao.setValue(filters.RestricoesYaraNao);
			this.bulkRenewalForm.controls.RestricaoSerasaGrupoSim.setValue(filters.RestricaoSerasaGrupoSim);
			this.bulkRenewalForm.controls.RestricaoSerasaGrupoNao.setValue(filters.RestricaoSerasaGrupoNao);
			this.bulkRenewalForm.controls.RestricoesYaraGrupoSim.setValue(filters.RestricoesYaraGrupoSim);
			this.bulkRenewalForm.controls.RestricoesYaraGrupoNao.setValue(filters.RestricoesYaraGrupoNao);
			this.bulkRenewalForm.controls.LCAndamentoSim.setValue(filters.LCAndamentoSim);
			this.bulkRenewalForm.controls.LCAndamentoNao.setValue(filters.LCAndamentoNao);
			this.bulkRenewalForm.controls.AlcadaAndamentoSim.setValue(filters.AlcadaAndamentoSim);
			this.bulkRenewalForm.controls.AlcadaAndamentoNao.setValue(filters.AlcadaAndamentoNao);
			this.bulkRenewalForm.controls.DeComCompras.setValue(filters.DeComCompras);
			this.bulkRenewalForm.controls.AteComCompras.setValue(filters.AteComCompras);
			this.bulkRenewalForm.controls.DeVigenciaGarantia.setValue(filters.DeVigenciaGarantia);
			this.bulkRenewalForm.controls.AteVigenciaGarantia.setValue(filters.AteVigenciaGarantia);
			this.bulkRenewalForm.controls.RepresentanteID.setValue(filters.RepresentanteID);
			this.bulkRenewalForm.controls.AnalistaID.setValue(filters.AnalistaID);
			this.bulkRenewalForm.controls.CTC.setValue(filters.CTC);
			this.bulkRenewalForm.controls.GC.setValue(filters.GC);
			this.bulkRenewalForm.controls.Diretoria.setValue(filters.Diretoria);
			this.bulkRenewalForm.controls.DePropostaRenovacao.setValue(filters.DePropostaRenovacao);
			this.bulkRenewalForm.controls.AtePropostaRenovacao.setValue(filters.AtePropostaRenovacao);
			this.bulkRenewalForm.controls.ClientesRenovadosSim.setValue(filters.ClientesRenovadosSim);
			this.bulkRenewalForm.controls.ClientesRenovadosNao.setValue(filters.ClientesRenovadosNao);
			this.bulkRenewalForm.controls.DeVigenciaLCAdicional.setValue(filters.DeVigenciaLCAdicional);
			this.bulkRenewalForm.controls.AteVigenciaLCAdicional.setValue(filters.AteVigenciaLCAdicional);
			this.bulkRenewalForm.controls.DeValorLCAdicional.setValue(filters.DeValorLCAdicional);
			this.bulkRenewalForm.controls.AteValorLCAdicional.setValue(filters.AteValorLCAdicional);
			this.bulkRenewalForm.controls.ConceitoCobrancaID.setValue(filters.ConceitoCobrancaID);
			
			this.bulkRenewalForm.controls.Faturamento.setValue(filters.Faturamento);
			this.bulkRenewalForm.controls.FaturamentoPeriodo.setValue(filters.FaturamentoPeriodo);
			this.bulkRenewalForm.controls.Atraso.setValue(filters.Atraso);
			this.bulkRenewalForm.controls.AtrasoPeriodo.setValue(filters.AtrasoPeriodo);
			this.bulkRenewalForm.controls.Prorrogacao.setValue(filters.Prorrogacao);
			this.bulkRenewalForm.controls.ProrrogacaoPeriodo.setValue(filters.ProrrogacaoPeriodo);

			this.bulkRenewalForm.controls.TipoGarantia.setValue(filters.TipoGarantia);
			this.bulkRenewalForm.controls.StatusGarantia.setValue(filters.StatusGarantia);
			//this.getBulkRenewalList();
		}
		console.log('filtros', filters);
	}

	clearFields() {
		this.bulkRenewalForm.controls.Codigo.setValue('');
		this.bulkRenewalForm.controls.NomeCliente.setValue('');
		this.bulkRenewalForm.controls.Apelido.setValue('');
		this.bulkRenewalForm.controls.Documento.setValue('');
		this.bulkRenewalForm.controls.NomeGrupo.setValue('');
		this.bulkRenewalForm.controls.DeVigenciaLC.setValue('');
		this.bulkRenewalForm.controls.AteVigenciaLC.setValue('');
		this.bulkRenewalForm.controls.Rating.setValue('');
		this.bulkRenewalForm.controls.DeValorLC.setValue('');
		this.bulkRenewalForm.controls.AteValorLC.setValue('');
		this.bulkRenewalForm.controls.ClienteTop10Sim.setValue('');
		this.bulkRenewalForm.controls.ClienteTop10Nao.setValue('');
		this.bulkRenewalForm.controls.DeConsultaSerasa.setValue('');
		this.bulkRenewalForm.controls.AteConsultaSerasa.setValue('');
		this.bulkRenewalForm.controls.RestricaoSerasa.setValue('');
		this.bulkRenewalForm.controls.RestricoesYaraSim.setValue('');
		this.bulkRenewalForm.controls.RestricoesYaraNao.setValue('');
		this.bulkRenewalForm.controls.RestricaoSerasaGrupoSim.setValue('');
		this.bulkRenewalForm.controls.RestricaoSerasaGrupoNao.setValue('');
		this.bulkRenewalForm.controls.RestricoesYaraGrupoSim.setValue('');
		this.bulkRenewalForm.controls.RestricoesYaraGrupoNao.setValue('');
		this.bulkRenewalForm.controls.LCAndamentoSim.setValue('');
		this.bulkRenewalForm.controls.LCAndamentoNao.setValue('');
		this.bulkRenewalForm.controls.AlcadaAndamentoSim.setValue('');
		this.bulkRenewalForm.controls.AlcadaAndamentoNao.setValue('');
		this.bulkRenewalForm.controls.DeComCompras.setValue('');
		this.bulkRenewalForm.controls.AteComCompras.setValue('');
		this.bulkRenewalForm.controls.DeVigenciaGarantia.setValue('');
		this.bulkRenewalForm.controls.AteVigenciaGarantia.setValue('');
		this.bulkRenewalForm.controls.RepresentanteID.setValue('');
		this.bulkRenewalForm.controls.AnalistaID.setValue('');
		this.bulkRenewalForm.controls.DePropostaRenovacao.setValue('');
		this.bulkRenewalForm.controls.AtePropostaRenovacao.setValue('');
		this.bulkRenewalForm.controls.ClientesRenovadosSim.setValue('');
		this.bulkRenewalForm.controls.ClientesRenovadosNao.setValue('');
		this.bulkRenewalForm.controls.DeVigenciaLCAdicional.setValue('');
		this.bulkRenewalForm.controls.AteVigenciaLCAdicional.setValue('');
		this.bulkRenewalForm.controls.DeValorLCAdicional.setValue('');
		this.bulkRenewalForm.controls.AteValorLCAdicional.setValue('');
		this.bulkRenewalForm.controls.ConceitoCobrancaID.setValue('');
		
		this.bulkRenewalForm.controls.Faturamento.setValue('');
		this.bulkRenewalForm.controls.FaturamentoPeriodo.setValue('');
		this.bulkRenewalForm.controls.Atraso.setValue('');
		this.bulkRenewalForm.controls.AtrasoPeriodo.setValue('');
		this.bulkRenewalForm.controls.Prorrogacao.setValue('');
		this.bulkRenewalForm.controls.ProrrogacaoPeriodo.setValue('');

		this.ctcList.forEach(ctc => ctc.checked = false);
  		this.gcList.forEach(gc => gc.checked = false);
  		this.directorList.forEach(director => director.checked = false);
		this.typeGuaranteeList.forEach(tg => tg.checked = false);
		this.statusGarantiasList.forEach(status => status.checked = false);
		this.updateSelected();

  		this.showDropdowns.ctcDropdown = false;
  		this.showDropdowns.gcDropdown = false;
  		this.showDropdowns.directorDropdown = false;
		this.showDropdowns.typeGuaranteeDropdown = false;
		this.showDropdowns.statusGuaranteeDropdown = false;

		this.bulkRenewalRequestService.cleanFilters();
	}

	searchClient() {
		if (this.bulkRenewalRequestService.getSelectClients().size > 0) {
			this.bulkRenewalRequestService.getBulkRenewalFiltered(this.token, this.orderby, this.sort, this.currentPage, this.qtdPorPagina).subscribe(
				result => {
					if (result.Success) {
						this.proposalRenovationList = result.Result;
						this.resultCount = result.Count;
						const clientsSelected = this.bulkRenewalRequestService.getSelectClients();

						if (clientsSelected.size > 0) {
							this.proposalRenovationList.forEach(function (item) {
								if (clientsSelected.has(item.ContaClienteID)) {
									item.Selected = true;
								}
							});

							this.lastFilterExecuted = 2;
						}
					}
				},
				error => {
					console.log(error);
				});
		}
		else {
			this.flashMessagesService.show('Não há clientes previamente selecionados!', { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	clearClient() {
		this.bulkRenewalRequestService.cleanSelectClients();
		this.bulkRenewalRequestService.cleanSelectClientsProperties();
		this.clearAll();
	}

	validateForm() { // Regra: O usuário deve preencher ao menos 1 campo do form para disparar a busca!
		const Keys = Object.keys(this.bulkRenewalForm.controls);
		let vazio = 0;

		Keys.forEach(function (v, i, arr) {
			const value = this.bulkRenewalForm.get(v).value;
			if (value  == "" ||
				value == null ||
				value == undefined ||
				(Array.isArray(value) && value.length === 0)) {
				vazio++;
			}
		}, this);

		return !(vazio == Keys.length);
	}

	changePerPage() {
		this.qtdPorPagina = this.qtdPorPaginaCustom;
		this.currentPage = 0;
		this.getBulkRenewalList();
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.page = $event;
		this.getBulkRenewalList();
	}

	onFilterChange(event, item) {
		if (event.target.checked) {
			this.bulkRenewalRequestService.setSelectClients(item.ContaClienteID);
			this.bulkRenewalRequestService.setSelectClientsProperties(item);
		}
		else {
			this.bulkRenewalRequestService.removeSelectClients(item.ContaClienteID);
			this.bulkRenewalRequestService.removeSelectClientsProperties(item);
		}
	}

	searchBulkRenewalList() {
		this.currentPage = 0;
		this.getBulkRenewalList();
	}

	getBulkRenewalList() {
		this.updateSelected();

		if (this.validateForm()) {
		  this.bulkRenewalRequestService.setFilters(this.bulkRenewalForm.value);
	  
		  const filters = this.bulkRenewalRequestService.getFilters();
		  filters.AtrasoDias = this.AtrasoDias;
		
		  console.log(filters);
		
		  this.bulkRenewalRequestService.getBulkRenewal(this.token, filters, this.orderby, this.sort, this.currentPage, this.qtdPorPagina).subscribe(
			result => {
			  if (result.Success) {
				this.generateFaturamentoColumns();
				this.proposalRenovationList = result.Result;
				this.resultCount = result.Count;
				const clientsSelected = this.bulkRenewalRequestService.getSelectClients();
	  
				if (clientsSelected.size > 0) {
				  this.proposalRenovationList.forEach(function (item) {
					if (clientsSelected.has(item.ContaClienteID)) {
					  item.Selected = true;
					}
				  });
				}
	  
				this.lastFilterExecuted = 1;
			  }
			},
			error => {
			  console.log(error);
			}
		  );
	  
		  this.clearClient();
		} else {
		  this.flashMessagesService.show('Preencha algum filtro para realizar a busca!', { cssClass: 'alert-danger', timeout: 6000 });
		}
	  }
	  

	exportExcel() {
		this.updateSelected();

		this.bulkRenewalRequestService.setFilters(this.bulkRenewalForm.value);

		const filters = this.bulkRenewalRequestService.getFilters();
		filters.AtrasoDias = this.AtrasoDias;

		this.bulkRenewalRequestService.exportExcel(this.token, filters).subscribe(
			result => {
				if (result) {
					const today = moment(new Date()).format("YYYY-MM-DD");

					saveAs(result, `Clientes_Renovacao_Filtro_${today}.xlsx`);

					this.flashMessagesService.show('Exportação realizada com sucesso!', { cssClass: 'alert-success', timeout: 6000 });
				} else {
					this.flashMessagesService.show('Exportação falhou!', { cssClass: 'alert-danger', timeout: 6000 });
				}
			},
			error => {
				console.log(error);
			});
	}

	consultaSerasa() {
		const clients = this.bulkRenewalRequestService.getSelectClients();

		if (clients.size > 0) {
			this.bulkRenewalRequestService.consultaSerasa(clients).subscribe(
				result => {
					if (result.Success) {
						this.flashMessagesService.show('Consulta realizada com sucesso!', { cssClass: 'alert-success', timeout: 6000 });
						// this.getBulkRenewalList();
					}
					else {
						this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
					}
				},
				error => {
					console.log(error);
				});
		}
		else {
			this.flashMessagesService.show("Nenhum cliente selecionado!", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	openModal() {
		const clients = this.bulkRenewalRequestService.getSelectClients();

		if (clients.size > 0) {
			let disposable = this.dialogService.addDialog(RenewalModalComponent, {
				title: 'Renovar Vigência do LC',
				message: 'Qual será a data da nova vigência a ser atribuída?',
				warning: ''
			},
				{
					backdropColor: 'rgba(0, 0, 0, 0.5)'
				});
		}
		else {
			this.flashMessagesService.show("Nenhum cliente selecionado!", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	tableScroll() {
		$(".biling-list" + " thead tr th:nth-child(1)").css("left", $(".titlesDiv").scrollLeft() - 1);
		$(".biling-list" + " tbody tr td:nth-child(1)").css("left", $(".titlesDiv").scrollLeft() - 1);
	}

	ngOnDestroy() {
		this.bulkRenewalRequestService.cleanFilters();
		this.bulkRenewalRequestService.cleanSelectClients();
		this.bulkRenewalRequestService.cleanSelectClientsProperties();
	}

	changeInputSelect(event) {
		if (event.target.checked) {
			this.selectAll();
		}
		else {
			this.clearAll();
		}
	}

	selectAll() {
		console.log(event);
		this.proposalRenovationList.forEach(item => {
			item.Selected = true;
			this.bulkRenewalRequestService.setSelectClients(item.ContaClienteID);
			this.bulkRenewalRequestService.setSelectClientsProperties(item);
		});
	}

	clearAll() {
		this.proposalRenovationList.forEach(item => {
			item.Selected = false;
			this.bulkRenewalRequestService.removeSelectClients(item);
			this.bulkRenewalRequestService.removeSelectClientsProperties(item);
		});
	}

	onChangeClearField(value: string, clearField: string): void {
		if (!value || value === 'null') {
		  this.bulkRenewalForm.controls[clearField].setValue('');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/bulk-renewal/component/bulk-renewal-request/bulk-renewal-request.component.ts